import GoalSelection from '../GoalSelection';

interface ContentSelectionProps {
  contentSelectionOption: 'High Yield' | 'Standard' | 'Comprehensive' | '';
  primaryExamName: string;
  primaryExamDate: string;
  isUsingFlashcards: boolean;
  setIsUsingFlashcards: (value: boolean) => void;
  totalUserSelectedFlashcards: number;
  setTotalUserSelectedFlashcards: (value: number) => void;
  isUsingQbank: boolean;
  setIsUsingQbank: (value: boolean) => void;
  totalUserSelectedVignettes: number;
  setTotalUserSelectedVignettes: (value: number) => void;
  setWorkloadOption: (value: string) => void;
}

const ContentSelection: React.FC<ContentSelectionProps> = ({
  contentSelectionOption,
  primaryExamName,
  isUsingFlashcards,
  isUsingQbank,
  setWorkloadOption,
}) => {
  return (
    <div className="content-selection">
      <div className="content-selection_options">
        <GoalSelection
          selectedGoal={contentSelectionOption}
          setSelectedGoal={setWorkloadOption}
          isUsingQbank={isUsingQbank}
          isUsingFlashcards={isUsingFlashcards}
          primaryExamName={primaryExamName}
        />
      </div>
    </div>
  );
};

export default ContentSelection;
